import { isSegFeatureEnabled } from "../../../providers";
import { isNonEmptyArray, isNonEmptyObject, isNumber } from "../../../utils";

export const isValidStoredDataFormat = (obj) => {
	if (
		!isNonEmptyObject(obj) ||
		!Object.keys(obj).every((key) => isNumber(parseInt(key, 10))) ||
		!Object.values(obj).every((list) => Array.isArray(list) && list.every((item) => isNumber(item)))
	) {
		return false;
	}
	return true;
};

export const dynamicElementDisplay = (tour, selector, action, value = null, delay = 200) =>
	new Promise((resolve, reject) => {
		try {
			const element = (typeof selector === "string" && document.querySelector(selector)) || selector;
			if (!element) {
				reject(new Error(`Element not found for selector: ${selector}`));
				return;
			}

			if (typeof element[action] === "function") {
				element[action](value);
			} else if (action === "value") {
				element.value = value;
			}

			setTimeout(() => {
				tour.refresh();
				resolve(element);
			}, delay);
		} catch (err) {
			reject(err);
		}
	});

export const getActivePlayableTours = (projectId, allTours, availableTours) =>
	Object.entries(allTours)
		.map(([key, tour]) => ({
			key,
			...tour,
			playable: (isNonEmptyArray(tour.flags) && projectId) || !tour?.flags,
			tooltipText: (isNonEmptyArray(tour.flags) && !projectId && tour?.tooltipText) || "",
		}))
		.filter(
			(tour) =>
				(!isNonEmptyArray(tour.flags) || isSegFeatureEnabled(tour.flags)) &&
				tour?.redirection &&
				typeof tour.redirection === "function" &&
				availableTours.some((pt) => pt.name === tour.key) &&
				((projectId && tour.locations.some((url) => url.includes("/projects/:projectId/"))) ||
					(!projectId && !tour.locations.some((url) => url.includes("/projects/:projectId/"))))
		);

export const refresh = (tour, conditionnedArray = []) => {
	/* eslint-disable no-underscore-dangle */
	const currentStep = tour._currentStep;
	/* conditionnedArray is the array of steps where dynamic change to DOM has been done */
	if (conditionnedArray?.some((x) => x === currentStep)) {
		setTimeout(() => {
			tour.start();
		}, 200);
	}
};

export const isElementPlaced = (el) => el && !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);

export const parseData = (data, fallback) => {
	try {
		return JSON.parse(data);
	} catch {
		return fallback;
	}
};
